import { PageType } from '@utils/pageConfig/Types';

export const ChartKeys = {
  [PageType.RETAILER_OVERVIEW]: {
    AVG_SELLING_PRICE: 'averageSellingPrice',
  },
  [PageType.RI_PRODUCT]: {
    MARKET: 'market',
    RETAILER: 'retailer',
  },
  [PageType.EXPLORE]: {
    MARKET: 'market',
    RETAILER: 'retailer',
    STACK_MARKET: 'stackMarket',
    STACK_RETAILER: 'stackRetailer',
    SEGMENT_STACK: 'segmentStack',
  },
};
